import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import {
  MODULE_PATH,
  USERS_CUSTOMERS,
  USER_FORM,
  CODE_LIST,
  USERS_LIST,
} from "./routesInterface";
import authStore from "@/flit2go-web-core/store/authModule";

export default [
  {
    path: MODULE_PATH,
    name: "People",
    meta: { requiresAuth: true },
    redirect: { name: "PeopleHome" },
    component: () => import("@/modules/People/People"),
    children: [
      // EMPLOYEES
      {
        path: "employees",
        name: "PeopleHome",
        component: () => import("@/modules/People/Pages/Employees/Index"),
        meta: {
          code: MODULE.PEOPLE.OWNER_EMPLOYEES,
        },
      },
      {
        path: "employees/detail/:id",
        name: "Person Details",
        component: () =>
          import("@/modules/People/Pages/Employees/EmployeeDetail.vue"),
        meta: {
          code: MODULE.PEOPLE.OWNER_EMPLOYEES,
        },
      },
      {
        path: "employees/form",
        name: "EmployeeForm",
        component: () =>
          import("@/modules/People/Pages/Employees/EmployeeForm"),
        meta: {
          breadcrumb: [],
          code: MODULE.PEOPLE.OWNER_EMPLOYEES,
        },
      },
      // USERS
      {
        path: "users",
        name: "UsersListPremium",
        component: () => import("@/modules/People/Pages/UsersPremiumList"),
        meta: {
          code: MODULE.PEOPLE.USERS,
        },
      },
      {
        path: "users/detail/:id",
        name: "UserPremiumDetailWrapper",
        component: () =>
          import("@/modules/People/Pages/UserPremium/UsersPremiumWrapper.vue"),
        meta: {
          code: MODULE.PEOPLE.USERS,
        },
        children: [
          {
            path: "detail",
            name: "UserPremiumDetail",
            component: () =>
              import(
                "@/modules/People/Pages/UserPremium/UsersPremiumDetail.vue"
              ),
            meta: {
              code: MODULE.PEOPLE.USERS,
            },
          },
          {
            path: "documentation",
            name: "UserPremiumDocumentation",
            component: () =>
              import(
                "@/modules/People/Pages/UserPremium/UsersPremiumDocumentation.vue"
              ),
            meta: {
              code: MODULE.PEOPLE.USERS,
            },
          },
          {
            path: "payments",
            name: "UserPremiumPayments",
            component: () =>
              import(
                "@/modules/People/Pages/UserPremium/UsersPremiumPayments.vue"
              ),
            meta: {
              code: MODULE.PEOPLE.USERS,
            },
          },
          {
            path: "contracts",
            name: "UserPremiumPaymentsContracts",
            component: () =>
              import(
                "@/modules/People/Pages/UserPremium/UserPremiumContracts.vue"
              ),
            meta: {
              code: MODULE.PEOPLE.USERS,
            },
          },
          {
            path: "companies",
            name: "UsersDetailCompanies",
            component: () =>
              import(
                "@/modules/People/Pages/UserPremium/UsersPremiumCompanies"
              ),
            meta: {
              code: MODULE.PEOPLE.USERS,
              breadcrumb: [],
            },
          },
          {
            path: "others",
            name: "UserPremiumOthers",
            component: () =>
              import("@/modules/People/Pages/UserPremium/UsersPremiumOthers"),
            meta: {
              code: MODULE.PEOPLE.USERS,
            },
          },
        ],
      },
      {
        path: "users/:usersType",
        name: "UsersList",
        component: () => import("@/modules/People/Pages/UsersList"),
        meta: {
          code: MODULE.PEOPLE.USERS,
        },
      },
      {
        path: "users/:usersType/detail/:id",
        name: "UsersDetail",
        component: () =>
          import("@/modules/People/Pages/Lead/Detail/UsersLeadCustomerWrapper"),
        meta: {
          code: MODULE.PEOPLE.USERS,
        },
        children: [
          {
            path: "detail",
            name: "Lead Detail",
            component: () =>
              import(
                "@/modules/People/Pages/Lead/Detail/UsersLeadCustomerDetail.vue"
              ),
            meta: {
              code: MODULE.PEOPLE.USERS,
            },
          },
          {
            path: "documentation",
            name: "Lead Documentation",
            component: () =>
              import(
                "@/modules/People/Pages/Lead/Detail/UsersLeadCustomerDocumentation.vue"
              ),
            meta: {
              code: MODULE.PEOPLE.USERS,
            },
          },
          {
            path: "payments",
            name: "Lead Payments",
            component: () =>
              import(
                "@/modules/People/Pages/Lead/Detail/UsersLeadCustomerPayments.vue"
              ),
            meta: {
              code: MODULE.PEOPLE.USERS,
            },
          },
          {
            path: "contracts",
            name: "Lead Contracts",
            component: () =>
              import(
                "@/modules/People/Pages/Lead/Detail/UsersLeadCustomerContracts.vue"
              ),
            meta: {
              code: MODULE.PEOPLE.USERS,
            },
          },
          {
            path: "companies",
            name: "Lead Companoes",
            component: () =>
              import(
                "@/modules/People/Pages/Lead/Detail/UsersLeadCustomerCompanies.vue"
              ),
            meta: {
              code: MODULE.PEOPLE.USERS,
            },
          },
          {
            path: "others",
            name: "Lead Others",
            component: () =>
              import(
                "@/modules/People/Pages/Lead/Detail/UsersLeadCustomerOthers.vue"
              ),
            meta: {
              code: MODULE.PEOPLE.USERS,
            },
          },
        ],
      },
      {
        path: "users/user/form",
        name: "UserForm",
        component: () => import("@/modules/People/Pages/UserForm"),
        meta: {
          breadcrumb: [
            {
              name:
                authStore &&
                authStore.state &&
                authStore.state.userProfile &&
                authStore.state.userProfile.ownerPerson &&
                authStore.state.userProfile.ownerPerson.premium
                  ? "common.user"
                  : "common.lead",
              link:
                authStore &&
                authStore.state &&
                authStore.state.userProfile &&
                authStore.state.userProfile.ownerPerson &&
                authStore.state.userProfile.ownerPerson.premium
                  ? USERS_LIST
                  : USERS_CUSTOMERS,
            },
            { name: "common.userForm", link: USER_FORM },
          ],
          code: MODULE.PEOPLE.USERS,
        },
      },
      // VALIDATION CODES
      {
        name: "Validation code",
        path: "codes",
        component: () => import("@/modules/People/Pages/Codes/CodeList"),
        meta: {
          breadcrumb: [{ name: "common.validationCodes", link: CODE_LIST }],
          code: MODULE.PEOPLE.VALIDATION_CODES,
        },
      },
      {
        name: "Validation Code Detail",
        path: "codes/detail/:id",
        component: () => import("@/modules/People/Pages/Codes/CodeDetail"),
        meta: {
          code: MODULE.PEOPLE.VALIDATION_CODES,
        },
      },
      {
        name: "Validation Code Form",
        path: "codes/form",
        component: () => import("@/modules/People/Pages/Codes/CodeForm"),
        meta: {
          code: MODULE.PEOPLE.VALIDATION_CODES,
        },
      },
      // DNR
      {
        path: "dnr/:type",
        name: "Dnr List",
        component: () => import("@/modules/People/Pages/DnrList.vue"),
        meta: {
          code: MODULE.PEOPLE.DNR,
        },
      },
      // COMMUNICATIONS
      {
        path: "communications/communication/form",
        name: "Communication Form",
        component: () => import("@/modules/People/Pages/CommunicationForm.vue"),
        meta: {
          code: MODULE.PEOPLE.COMMUNICATIONS,
        },
      },
      {
        path: "communications",
        name: "Communications List",
        component: () =>
          import("@/modules/People/Pages/CommunicationsList.vue"),
        meta: {
          code: MODULE.PEOPLE.COMMUNICATIONS,
        },
      },
      // organization
      {
        path: "companies",
        name: "Organizations List",
        component: () =>
          import("@/modules/People/Pages/Organization/OrganizationsList.vue"),
        meta: {
          code: MODULE.PEOPLE.COMPANIES,
        },
      },
      {
        path: "companies/form",
        name: "Organization Form",
        component: () =>
          import("@/modules/People/Pages/Organization/OrganizationForm.vue"),
        meta: {
          code: MODULE.PEOPLE.COMPANIES,
        },
      },
      {
        path: "companies/detail/:organizationId",
        name: "Organization Detail",
        redirect: { name: "Organization Detail Information" },
        component: () =>
          import(
            "@/modules/People/Pages/Organization/OrganizationDetailWrapper"
          ),
        meta: {
          code: MODULE.PEOPLE.COMPANIES,
        },
        children: [
          {
            path: "information",
            name: "Organization Detail Information",
            component: () =>
              import(
                "@/modules/People/Pages/Organization/OrganizationDetailInformation"
              ),
            meta: {
              code: MODULE.PEOPLE.COMPANIES,
            },
          },
          {
            path: "billing",
            name: "Organization Detail Billing",
            component: () =>
              import(
                "@/modules/People/Pages/Organization/OrganizationDetailBilling"
              ),
            meta: {
              code: MODULE.PEOPLE.COMPANIES,
            },
          },
          {
            path: "drivers",
            name: "Organization Detail Drivers",
            component: () =>
              import(
                "@/modules/People/Pages/Organization/OrganizationDetailDrivers"
              ),
            meta: {
              code: MODULE.PEOPLE.COMPANIES,
            },
          },
          {
            path: "rentals",
            name: "Organization Detail Rentals",
            component: () =>
              import(
                "@/modules/People/Pages/Organization/OrganizationDetailRentals"
              ),
            meta: {
              code: MODULE.PEOPLE.COMPANIES,
            },
          },
          {
            path: "notesAndTags",
            name: "Organization Detail Notes And Tags",
            component: () =>
              import(
                "@/modules/People/Pages/Organization/OrganizationDetailNotesAndTags"
              ),
            meta: {
              code: MODULE.PEOPLE.COMPANIES,
            },
          },
        ],
      },
    ],
  },
];
